import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { AUTHOR, COVER_IMAGE } from "../lib/site";

const CoverFace = () => (
  <div className="absolute inset-0 overflow-hidden rounded-r-md rounded-l-sm bg-[#1a1420]">
    <div className="absolute inset-0 bg-[radial-gradient(120%_80%_at_70%_20%,#5e253b_0%,#2a1625_45%,#140f18_100%)]" />
    <svg className="absolute inset-x-0 top-[38%] w-full opacity-80" viewBox="0 0 300 80" preserveAspectRatio="none">
      <path d="M0 40 C 30 -10, 55 -10, 80 40 S 125 90, 150 40 S 185 15, 205 40 S 230 48, 250 40 L 300 40"
        fill="none" stroke="#e3ba73" strokeWidth="1.4" />
    </svg>
    <div className="absolute inset-0 p-7 flex flex-col justify-between">
      <span className="font-mono-d text-[10px] tracking-[0.35em] text-[#e3ba73]/90 uppercase">A Memoir</span>
      <div>
        <h3 className="font-serif-d gold-foil text-[2.6rem] leading-[0.92] font-semibold">
          Bipolar<br />Is Who<br /><em className="font-normal">I Am</em>
        </h3>
        <div className="mt-5 h-px w-16 bg-[#e3ba73]/60" />
        <p className="mt-4 font-mono-d text-[11px] tracking-[0.3em] uppercase text-[#f4ede2]/90">{AUTHOR.name}</p>
      </div>
    </div>
    <div className="absolute left-0 inset-y-0 w-4 bg-gradient-to-r from-black/60 to-transparent" />
    <div className="absolute right-10 -top-1 w-3 h-24 bg-[#e3ba73] [clip-path:polygon(0_0,100%_0,100%_100%,50%_85%,0_100%)]" />
  </div>
);

export const BookCover = ({ className = "" }) => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [12, -12]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-18, 18]), { stiffness: 120, damping: 14 });
  const glare = useTransform(mx, [-0.5, 0.5], ["20%", "80%"]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };

  return (
    <div className={`[perspective:1400px] ${className}`} onMouseMove={onMove} onMouseLeave={reset} data-testid="hero-book-3d-cover">
      <motion.div style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="relative w-[230px] sm:w-[280px] lg:w-[320px] aspect-[2/3] mx-auto">
        <div className="absolute inset-0 translate-y-10 scale-90 rounded-full bg-[#e3ba73]/20 blur-3xl" style={{ transform: "translateZ(-80px)" }} />
        <div className="absolute top-[1.5%] bottom-[1.5%] right-0 w-[28px] bg-[repeating-linear-gradient(90deg,#efe6d6_0_1px,#d9cdb8_1px_2px)] rounded-r-sm"
          style={{ transform: "rotateY(90deg) translateZ(-14px) translateX(14px)", transformOrigin: "right" }} />
        <div className="absolute inset-0 shadow-[30px_40px_60px_-20px_rgba(0,0,0,0.8)]" style={{ transform: "translateZ(14px)" }}>
          {COVER_IMAGE ? (
            <img src={COVER_IMAGE} alt={`${AUTHOR.book} cover`} className="absolute inset-0 w-full h-full object-cover rounded-r-md rounded-l-sm" />
          ) : (
            <CoverFace />
          )}
          <motion.div className="absolute inset-0 rounded-r-md pointer-events-none mix-blend-soft-light"
            style={{ background: useTransform(glare, (g) => `radial-gradient(circle at ${g} 20%, rgba(255,255,255,.45), transparent 55%)`) }} />
        </div>
      </motion.div>
    </div>
  );
};
